module.exports = __webpack_public_path__ + "static/media/icon_check.3a93339c.svg";